import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  TenantResponse,
} from '@/repositories/generated';

type TenantAutocompleteStoreState = {
  tenants: TenantResponse[];
};

export const useTenantAutocompleteStore = defineStore('tenantAutocomplete', {
  state: (): TenantAutocompleteStoreState => ({
    tenants: [],
  }),
  actions: {
    async getTenants() {
      // 一度取得したらキャッシュから取得
      if (this.tenants.length) {
        return this.tenants;
      }

      const res = await AutocompleteRepository.searchTenant({
        term: undefined,
      });
      this.tenants = res;
      return res;
    },
  },
});
